import { useCandidateAuth } from 'features/auth/AuthProvider';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTES } from 'shared/constants';

export default function useGoBackToOpportunities() {
    const { accessToken } = useCandidateAuth();
    const navigate = useNavigate();

    const handleBackClick = useCallback(() => {
        navigate({ pathname: APP_ROUTES.candidateOffers });
    }, [ navigate ]);

    return accessToken.oldAvailabilityToken ? undefined : handleBackClick;
}
